import React from 'react';
import Button from '../../../../partials/Button';
import ButtonsHolder from '../../../../partials/Button/ButtonsHolder';
import HTMLContent from '../../../../partials/HTMLContent';
import './Splash.scss'
const Splash = (props) =>{

    const {content, buttons, backButtonHandler} = props

    return(
        <div className="comms-splash">
            <div className="comms-splash-column" >
                <div className="back-btn-container">
                    <Button variant='back' text="back" onClick={backButtonHandler} />
                </div>
                <div className="comms-splash-intro">
                    
                    <div className="comms-splash-intro-block">
                        <HTMLContent variant="wrapped" html={content.__html} />

                    </div>
                </div>
                <ButtonsHolder orientation="center" >
                    <Button text={buttons[0].text} onClick={buttons[0].action} />
                </ButtonsHolder>
                    

            </div>
            <div className="comms-splash-column">
                <img src="media/img/full-length-test-photo.png" alt="Overview" className="img-responsive img_bdr" />
            </div>
        </div>
    )
}
export default Splash